import { css } from "@emotion/react";
import { Theme } from "../styles/theme";

export const boldTokenFont = (theme: Theme) => css`
  font-size: ${theme.fontSize["7"]};
  font-weight: ${theme.fontWeights["work-sans-0"]};
`;

export const amountFont = (theme: Theme) => css`
  font-family: ${theme.fontFamilies.Primary};
  font-weight: ${theme.fontWeights["work-sans-0"]};
  font-size: ${theme.fontSize["7"]};
  color: ${theme.font.primary.default};
`;

export const reviewText = (theme: Theme) => css`
  font-family: ${theme.fontFamilies.Primary};
  color: ${theme.font.primary.default};
  font-weight: ${theme.fontWeights["work-sans-0"]};
  font-size: ${theme.fontSize["6"]};
`;
export const reviewUsdFont = (theme: Theme) => css`
  font-family: ${theme.fontFamilies["work-sans"]};
  font-size: ${theme.fontSize["5"]};
`;

export const tradeHeaderFont = (theme: Theme) => css`
  font-family: ${theme.fontFamilies["work-sans"]};
  color: ${theme.font.secondary.default};
`;

export const rowCss = css`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: flex-start;
`;

export const buttonAsAnchorTag = css`
  text-decoration: underline;
  background: none;
  border: 0;
  padding: 0;
  font-weight: 550;
  color: #192e2e;
`;

export const marginRightOnApprovalStates = css`
  margin-right: 5px;
`;

export const approvalSpinnerWrapper = css`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
`;

export const approvedCss = css`
  margin-left: 3px;
  line-height: 20px;
`;

export const warningCss = css`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #ffe888;
  display: flex;
  align-items: start;
`;
export const textSecondary = css`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #ccd1d1;
  text-align: center;
`;

export const verticalAlignedFlexbox = css`
  display: flex;
  align-items: center;
`;

export const ratesInfo = css`
  font-size: 14px;
`;

export const flexBetween = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const fadeIn = css`
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease;
  animation-duration: 0.55s;
`;
